module.exports = __webpack_public_path__ + "static/img/9.dbee9b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/sp/9.png
// module id = OOEA
// module chunks = 0